import React, { useMemo, useState } from 'react';
import { Link } from 'tdesign-react';
import { isVoid } from '@/utils/common';
import JSONModal from '@/components/JSONModal';

export default function MessageDataModal({ data: propsData }) {
  const [visible, setVisible] = useState(false);
  const data = useMemo(() => {
    if (isVoid(propsData)) {
      return '';
    }
    if (typeof propsData === 'object') {
      return JSON.stringify(propsData);
    }
    return propsData;
  }, [propsData]);

  const strEllipsis = `${data.substring(0, 50)}...`;

  const strNode = data.length > 50 ? strEllipsis : data;

  const handleClose = () => setVisible(false);

  return (
    <div>
      {strNode}
      {strNode && (
        <Link style={{ marginLeft: 10 }} theme='primary' onClick={() => setVisible(true)}>
          展开
        </Link>
      )}

      <JSONModal visible={visible} handleClose={handleClose} json={data} title='Data' />
    </div>
  );
}
